var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBubblePending = function SvgIconBubblePending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 192 192",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 164c37.555 0 68-30.445 68-68s-30.445-68-68-68-68 30.445-68 68 30.445 68 68 68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.52 135.37 96 164H37.21c-7.13 0-10.7-8.62-5.66-13.66l14.97-14.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM96 104a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM126 104a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    fill: "#fff"
  })));
};
export default SvgIconBubblePending;